// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"box_wrapper__2NYfE"};